import clsx from "clsx";

import { IconPlaneArrival, IconPlaneDeparture } from "@/components/Icons";
import { ArrowRightIcon } from "@/components/Icons/rtlReadyIcons";

const segmentDirectionIconMapping = {
  departure: IconPlaneDeparture,
  return: IconPlaneArrival,
};

type Props = {
  routeLabels: [string | undefined, string | undefined];
  segmentDirection?: "departure" | "return";
  variant?: "small" | "big";
};

export const FlightRouteLabel = ({
  routeLabels,
  segmentDirection,
  variant = "big",
}: Props) => {
  const Icon = segmentDirection
    ? segmentDirectionIconMapping[segmentDirection]
    : undefined;

  return (
    <div
      className={clsx("flex items-center justify-start gap-1", {
        "text-lg": variant === "big",
        "text-base font-normal": variant === "small",
      })}
    >
      {Icon ? <Icon className="size-6 shrink-0" /> : null}
      <div>{routeLabels[0]}</div>
      <ArrowRightIcon
        size={14}
        color="var(--color-black)"
        className="shrink-0"
      />
      <div>{routeLabels[1]}</div>
    </div>
  );
};
